module.exports = __webpack_public_path__ + "img/im.f7e83cac.svg";